import React from "react";

import CopyButton from "../../../common/CopyButton/CopyButton";
import CopyIcon from "../../../Icon-SVG/CopyIcon";

import "./styles.scss";

export const EMPTY_VALUE = "—";

// A single key/value line. `mono` is for hashes and other fixed-width data,
// `copyable` keeps a long value on one line, ellipsised, next to a copy button,
// `title` overrides the tooltip when the value is not plain text.
export const InfoRow = ({ label, value, title, mono = false, copyable = false }) => {
  // Keep 0 and false: only a missing or blank value falls back to the em dash.
  const hasValue = value !== null && value !== undefined && value !== "";
  const plainText = typeof value === "string" ? value : undefined;

  const className = [
    "general-info__value",
    mono ? "general-info__value--mono" : "",
    hasValue && copyable ? "general-info__value--copyable" : "",
    hasValue ? "" : "general-info__value--empty",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <dt className="general-info__label">{label}</dt>
      <dd className={className} title={title || plainText}>
        {!hasValue ? (
          EMPTY_VALUE
        ) : copyable ? (
          <>
            <span className="general-info__truncate">{value}</span>
            <CopyButton
              title={`Copy ${label}`}
              itemToCopy={plainText || ""}
              icon={CopyIcon}
              iconWidth={16}
              iconHeight={16}
              successMessage={`${label} copied to clipboard!`}
              failureMessage={`Could not copy the ${label}.`}
            />
          </>
        ) : (
          value
        )}
      </dd>
    </>
  );
};

// The "invisible table" every information card on the report pages shares:
// no grid lines, but every value starts on the same column.
const InfoTable = ({ children }) => <dl className="general-info__table">{children}</dl>;

export default InfoTable;
